import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import ImpedanceIcon from 'material-ui-icons/Timeline';

import editor from './assets/impedance-mockup.jpg';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing.unit * 4,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 24,
  },
  preview: {
    width: '100%',
    maxHeight: 400,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: 30,
    marginRight: 16,
    color: theme.palette.primary.main
  }
});

export function Impedance({ classes, onButtonClick }) {
  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item xs={12} sm={6}>
          <img
            src={editor}
            alt="3D Printed Circuit Board Editor"
            className={classes.preview}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.text}>
            <Typography className={classes.title} variant="title" component="h2" color="inherit" gutterBottom>
              <ImpedanceIcon className={classes.icon} /> Impedance Calcuator
            </Typography>
            <Typography variant="subheading" component="h3" color="inherit" >
              Calculate transmission line impedance and insertion loss using ITEQ's robust
              frequency dependent material DK & DF library.
            </Typography>
          </div>
          <div className={classes.actions}>
            <Button
              onClick={onButtonClick}
              className={classes.button}
              variant="raised"
            >
              Find out More
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

Impedance.propTypes = {
  classes: PropTypes.object.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(Impedance);


// WEBPACK FOOTER //
// ./src/components/HomePage/Iteq/Impedance.jsx